import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import { Theme } from 'studio-components';
import { ThemeProviderService } from 'src/app/shared/services/theme-provider.service';
import tippyJs, { Instance } from 'tippy.js';

@Component({
  selector: 'studio-popup-menu',
  templateUrl: './popup-menu.component.html',
  styleUrls: ['./popup-menu.component.scss'],
  providers: [ThemeProviderService],
})
export class PopupMenuComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('contentEl') content: ElementRef<Element>;

  @HostBinding('class') @Input() theme: Theme = 'light';
  @Input() offset: [number, number] = [0, 8];
  @Input() testId: string;
  @Output() menuOpened = new EventEmitter();

  private popupInstance: Instance;

  constructor(
    @SkipSelf() private triggerEl: ElementRef<Element>,
    private themeProviderService: ThemeProviderService,
  ) {}

  ngOnInit() {
    // call explicitly to handle default value where ngOnChanges is not triggered
    this.themeProviderService.setTheme(this.theme);
  }

  ngAfterViewInit() {
    this.popupInstance = tippyJs(this.triggerEl.nativeElement, {
      content: this.content.nativeElement,
      allowHTML: true,
      interactive: true,
      trigger: 'click',
      maxWidth: 'auto',
      duration: [0, 0],
      arrow: false,
      placement: 'bottom-end',
      offset: this.offset,
      onShow: () => {
        this.menuOpened.emit();
      },
    });
  }

  ngOnDestroy() {
    this.popupInstance.destroy();
  }

  ngOnChanges({ theme }: SimpleChanges) {
    // handle subsequent changes to theme
    if (theme) {
      this.themeProviderService.setTheme(theme.currentValue);
    }
  }

  // workaround as tippy popup is not automatically hidden when a menu item is clicked
  protected menuClicked() {
    this.popupInstance.hide();
  }
}
